import React, { useReducer } from "react";
import reducer from './reducer'
import getLocalStorage from '../utils/getLocalStorage'

const initialState = {
    query: {
        per_page: 15,
        page: 1,
        user: getLocalStorage('user_id')
    },
    totalPages: 0,
    user: {},
    orders: [],
    products: [],
    loader: false
}

const AppStore = React.createContext(initialState);
const DispatchContext = React.createContext(undefined);

export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return <AppStore.Provider value={state}>
        <DispatchContext.Provider value={dispatch}>
            {children}
        </DispatchContext.Provider>
    </AppStore.Provider>;
}

export const useUIState = () => React.useContext(AppStore);

export const useUIDispatch = () => {
    const dispatch = React.useContext(DispatchContext);

    if (dispatch === undefined) {
        throw new ErrorEvent('Check the provider');
    }

    return dispatch;
}